import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-framer-motion', 'BrandFramerMotion', [["path",{"d":"M12 12l-8 -8v16l16 -16v16l-4 -4"}],["path",{"d":"M20 12l-8 8l-4 -4"}]]);